import { ENDPOINT_HAR_REASSOCIATE } from '@terra/shared-contracts-feature-flags';
import { isE2eTestMode } from '@terra/shared-utils';
import { useFeatureFlags } from './useFeatureFlags';

export function useHarReassociateEnabled(): boolean {
  const { isFeatureFlagEnabled } = useFeatureFlags(ENDPOINT_HAR_REASSOCIATE);

  if (isE2eTestMode()) {
    return true;
  }

  return isFeatureFlagEnabled;
}
